import React from 'react'
import { motion } from 'framer-motion'

const ValuesSection = () => {
  const stages = [
    {
      title: "Ship & Iterate",
      description:
        "We move swiftly, refining our approach with every step to maintain a leading edge.",
    },
    {
      title: "Trusted Pair of Hands",
      description:
        "Dependable and steadfast, we are always there when it matters most.",
    },
    {
      title: "Overdeliver on the Promise",
      description:
        "Exceeding expectations is our standard, going beyond what’s assured.",
    },
    {
      title: "Clear is Kind",
      description:
        "Transparent, honest communication keeps everyone on the same page.",
    },
  ];

  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { 
      opacity: 1, 
      y: 0, 
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  return (
    <div>
      <h1 className='text-4xl mb-9 mt-5 font-bold'>
        Our <span className='text-primaryColor'>Values</span>
      </h1>
      <motion.div 
        className='grid grid-cols-1 relative md:grid-cols-2 xl:grid-cols-3 gap-5'
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {stages.map((stage, index) => (
          <motion.div 
            key={index} 
            className="py-5 rounded-sm"
            variants={cardVariants}
          >
            <div className="flex items-center gap-3 mb-2.5">
              <div className="px-1 border rounded-full border-primaryColor relative">
                <div className="text-lg text-primaryColor rounded-full py- px-2 border-4 border-primaryColor my-1 bg-white">
                  {index + 1}
                </div>
              </div>
              <h1 className="text-xl font-bold text-gray-800 my-2">{stage.title}</h1>
            </div>
            <p className="text-lg text-gray-700">{stage.description}</p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  )
}

export default ValuesSection
